// MF-554 — Card 'kpi-value': one big number per declared field (e.g. "Students 1,882").
import { Box, Typography } from '@mui/material'
import { SUMMARY_PALETTE } from '../../../Dashboard/StudentSummary/summary.palette'
import { fmtValue } from '../boardTheme'

const KpiValueCard = ({ data }) => {
  const row = data?.rows?.[0] || {}
  const fields = data?.encoding?.fields || []
  const decimals = data?.meta?.card?.options?.decimals || 0
  return (
    <Box
      sx={{ display: 'flex', gap: 3, alignItems: 'center', height: '100%', flexWrap: 'wrap', px: 0.5, pb: 1 }}
    >
      {fields.map((f) => (
        <Box key={f.key} sx={{ minWidth: 0 }}>
          <Typography sx={{ fontSize: 34, fontWeight: 800, lineHeight: 1, color: SUMMARY_PALETTE.good }}>
            {fmtValue(row[f.key], decimals)}
            {f.unit || ''}
          </Typography>
          {fields.length > 1 ? (
            <Typography sx={{ fontSize: 12, color: SUMMARY_PALETTE.muted, mt: 0.5 }}>{f.label}</Typography>
          ) : null}
        </Box>
      ))}
    </Box>
  )
}

export default KpiValueCard
